import { IConversion } from "src/app-telehealth-demo/util/utils";

interface IProps {
    conversion: IConversion;
}

const SelfSchedulingStep: React.FC<IProps> = ({ conversion }) => {
    return (
        <div className="container-fluid w-100 vh-100">
            <iframe
                src={conversion.selfSchedulingLink}
                width="100%"
                height="100%"
                style={{ border: "none" }}
            />
        </div>
    );
};

export default SelfSchedulingStep;
